<template>
  <div>
    <v-row justify="start">
      <h3 class="ml-2 mb-1 primary--text text-uppercase textoAjustado"><slot></slot></h3>
    </v-row>
    <v-row align="center" class="mb-3">
      <v-divider class="dividerSubtitle primary"/>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'o-medium-title',
  props: {
    center: {
      type: Boolean,
      default: false
    }
  }
}
</script>

